import { render, staticRenderFns } from "./GeneralPanel.vue?vue&type=template&id=750dcab0&scoped=true&"
import script from "./GeneralPanel.vue?vue&type=script&lang=js&"
export * from "./GeneralPanel.vue?vue&type=script&lang=js&"
import style0 from "./GeneralPanel.vue?vue&type=style&index=0&id=750dcab0&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "750dcab0",
  null
  
)

export default component.exports